import React from 'react';
import { object } from 'prop-types';
import { Button } from '@ajaibid/components';

import useOrderAction from '../../hooks/useOrderAction';
import { styActionButtonsContainer } from './style';

/**
 * @typedef {import('@services/api/stock/order/regular').OrderRegular} OrderRegular
 */

/**
 * @param {object}        Params
 * @param {OrderRegular}  Params.order
 */
function ActionButtons({ order }) {
  const isAmendable = order.is_amend === '1';
  const isCancelable = order.is_cancel === '1';

  const { amend, withdraw } = useOrderAction('REGULAR');

  return (
    <span className={styActionButtonsContainer}>
      {isAmendable && (
        <Button variant="secondary" minWidth={null} onClick={() => amend(order)}>
          Ubah
        </Button>
      )}
      {isCancelable && (
        <Button variant="secondary" minWidth={null} onClick={() => withdraw(order)}>
          Batalkan
        </Button>
      )}
    </span>
  );
}

ActionButtons.propTypes = {
  order: object.isRequired,
};

export default ActionButtons;
